<template>
	<section class="app-container">

		<article class="page" v-html="displayArticle.html" @click="onClick"></article>
		
		<ErrorAlert v-if="error" :error="error" />
		<Spinner v-if="loading" />
		
	</section>
</template>

<script>
import Article from '../../services/article';
import Spinner from '../../components/shared/Spinner';
import ErrorAlert from '../../components/shared/ErrorAlert';
import GridBuilder from '../../util/grid-builder';
import LinkHighlight from '../../util/link-highlight';

export default {
	name: 'IndexLanding',
	components: {
		Spinner,
		ErrorAlert,
	},
	data() {
		return {
			article: {},
			error: null,
			loading: false,
			displayArticle: {}
		};
	},
	mounted() {
		this.getIndexArticle();
	},
	methods: {
		getIndexArticle() {
			this.loading = true;
			Article.instance()
				.getIndexLandingArticle()
				.then((result) => {
					this.error = null;
					if (result.data) {
						this.article = result.data;
						this.highlightLinks();
						this.generateGrid();
					}
					this.loading = false;
				})
				.catch((err) => {
					this.loading = false;
					this.error = err;
				});
		},
		highlightLinks: function () {
			let linkHighlighter = new LinkHighlight(
				this.article.html,
				this.article.articlesMinimal,
				this.article.id
			);
			this.article.html = linkHighlighter.getHighlightHtml();
		},
		generateGrid: async function () {
			let gridBuilder = new GridBuilder(this.article.html);
			let displayHtml = await gridBuilder.getDisplayHtmlAsync();
			this.boxArticlesIds = gridBuilder.getBoxedArticleIds();
			this.displayArticle = { ...this.article, html: displayHtml };
			this.loading = false;
		},
		onClick: function(event) {
			// eslint-disable-next-line
		}
	},
};
</script>